import axios from 'axios';

export default {
    FETCH_CORPORATIONS ({commit, dispatch}){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            axios.get('corporations')
                .then((response) => {
                    const { data: { data } } = response;
                    localStorage.setItem('corporations', JSON.stringify(data));
                    commit('SET_CORPORATIONS', data);
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
  FETCH_CORPORATIONS_WITH_GIFT_CODES ({commit, dispatch}){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get('corporations/getCorporationsWithGifts')
        .then((response) => {
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data.payload);
        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  FETCH_CORPORATIONS_CHILD ({commit, dispatch}, parentAcctId){
    //https://adminapi1.dev-tonenetworks.com/v1/groupdef/getParentChildCorporations/{parentAcctId}
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get(`groupdef/getParentChildCorporations/${parentAcctId}`)
        .then((response) => {
          const { data: { data } } = response;
          // localStorage.setItem('corporations', JSON.stringify(data));
          commit('SET_CORPORATIONS', data);
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  FETCH_CORPORATIONS_CODES ({commit, dispatch}){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get('corporations/getCorporationsforAllUsers')
        .then((response) => {
          const { data: { data } } = response;
          // localStorage.setItem('corporations', JSON.stringify(data));
          // commit('SET_CORPORATIONS', data);
          commit('TOGGLE_LOADING', false);
          resolve(data.payload);
        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  FETCH_CORPORATIONS_PKGS({commit, dispatch}){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get('plans/getPlansforAllUsers')
        .then((response) => {
          const { data: { data } } = response;
          // localStorage.setItem('corporations', JSON.stringify(data));
          // commit('SET_CORPORATIONS', data);
          commit('TOGGLE_LOADING', false);
          resolve(data.payload);
        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  FETCH_SUBSCRIBERS ({commit, dispatch}){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get('/registration/getAllSubscriberReport')
        .then((response) => {
          const { data: { data } } = response;
          // localStorage.setItem('corporations', JSON.stringify(data));
          commit('SET_SUBSCRIBERREPORT', data);
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  FETCH_TEASER_TEMPLATE ({commit, dispatch}, contentId){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get(`/emailapis/getTeaserEmailContent/${contentId}`)
        .then((response) => {
          const { data: { data } } = response;
          // localStorage.setItem('corporations', JSON.stringify(data));
          // commit('SET_SUBSCRIBERREPORT', data);
          commit('TOGGLE_LOADING', false);
          resolve(data.payload);
        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  ADD_TEASER_LINE({commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      console.log("add teaser payload : ", payload);
      axios.post('emailapis/insertTeaserEmailSubjects', payload).then((response) => {
          console.log('ADD_TEASER_LINE action fetch response : ', response);
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('ADD_TEASER_LINE action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  FETCH_USER_DETAILS ({commit, dispatch}, userId){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get(`/registration/getByUserId/${userId}`)
        .then((response) => {
          // const { data: { data } } = response;
          // localStorage.setItem('corporations', JSON.stringify(data));
          // commit('SET_SUBSCRIBERREPORT', data);
          // console.log('data to be sent', response.data)
          commit('TOGGLE_LOADING', false);
          resolve(response.data);
        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  FETCH_SUBSCRIBERS_FREETRIAL ({commit, dispatch}){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get('/registration/getNonCorpTrialUsers')
        .then((response) => {
          const { data: { data } } = response;
          // localStorage.setItem('corporations', JSON.stringify(data));
          commit('SET_SUBSCRIBERREPORT', data);
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  FETCH_PARENT_SUPER_USERS ({commit, dispatch}, parentId){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get(`/groupdef/getParentSuperSuperUsers/${parentId}`)
        .then((response) => {
          const { data: { data } } = response;
          // localStorage.setItem('corporations', JSON.stringify(data));
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  FETCH_SUBSCRIBERS_BY_QUERY ({commit, dispatch}, qry){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get(`/registration/getSubscriberReportFiltered?${qry}`)
        .then((response) => {
          const { data: { data } } = response;
          // localStorage.setItem('corporations', JSON.stringify(data));
          // commit('SET_SUBSCRIBERREPORT', data);
          commit('TOGGLE_LOADING', false);
          resolve(data.payload);
        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  DOWNLOAD_CSV ({commit}, filterType){
      console.log('filter type sent', filterType)
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get(`/registration/downloadSubscriberCSV/${filterType}`)
        .then((response) => {
          // const { data: { data } } = response;
          console.log(' response', response)
          // localStorage.setItem('corporations', JSON.stringify(data));
          // commit('SET_SUBSCRIBERREPORT', data);
          commit('TOGGLE_LOADING', false);
          // resolve(data);
        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  GET_CORP_USERS_DETAILS ({ commit }, corpId) {
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      // axios.post('login/authenticate', payload)
      axios.get(`corporations/getCorporationAllUsers/${corpId}`)
        .then((response) => {
          console.log('user response', response)
          const { data: { data } } = response;
          console.log('payload check', data)
          if (data && data.length > 0) {
            commit('TOGGLE_LOADING', false);
            resolve(data)
          } else {
            commit('TOGGLE_LOADING', false);
            resolve(null);
          };
        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  GET_CORP_USERS ({ commit }, corpId) {
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      // axios.post('login/authenticate', payload)
      axios.get(`corporations/getCorporationAllUsers/${corpId}`)
        .then((response) => {
          console.log('user response', response)
          const { data: { data } } = response;
          console.log('payload check', data)
          if (data && data.length > 0) {
            let userReference = data.map(x => {
              return {
                name: x.userId + ' - ' + x.firstName + ' ' + x.lastName,
                id: x.userId
              }
            })
            resolve(userReference)
          } else {
            commit('TOGGLE_LOADING', false);
            resolve(null);
          };
        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  GET_CORP_GROUPS ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      // axios.post('login/authenticate', payload)
      axios.get(`groupdef/loadGroupDefinitions`)
        .then((response) => {
          const { data: { data : { payload } } } = response;
          console.log('get group response', payload)
          resolve(payload)
        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
    GET_SELECTED_CORPORATION ({ commit }, id) {
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            axios.get(`/corporations/${id}`)
                .then((response) => {
                    commit('TOGGLE_LOADING', false);
                    const { data: { data } } = response;
                    commit('SET_SELECTED_CORPORATION', data);
                    console.log('SET_SELECTED_CORPORATION data ', data);
                    resolve(data);
                })
                .catch((error) => {
                    commit('TOGGLE_LOADING', false);
                    console.log('GET_SELECTED_PLAN error ', error);
                    reject(error);
                });
        })
    },

    DELETE_CORPORATION ({ commit }, params) {
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            axios.delete(`/corporations/${params.corporationId}?isDelete=${params.isDelete}`)
                .then((response) => {
                    commit('TOGGLE_LOADING', false);
                    const { data: { data } } = response;
                    console.log('DELETE_SELECTED_PLAN response ', response);
                    resolve(data);
                })
                .catch((error) => {
                    commit('TOGGLE_LOADING', false);
                    console.log('DELETE_SELECTED_PLAN error ', error);
                    reject(error);
                });
        })

    },
  UPDATE_USER_CORPORATION({commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      return axios.get(`/registration/convertTrial2CorpGift/${payload.userId}/${payload.corpGiftId}`)
        .then((response) => {
          commit('TOGGLE_LOADING', false);
          const { data: { data } } = response;
          console.log('UPDATE_USER_CORP ', response);
          resolve(data);
        })
        .catch((error) => {
          commit('TOGGLE_LOADING', false);
          console.log('UPDATE_EXPERT error ', error);
          reject(error);
        })
    })
  },
  UPDATE_SUPERUSER_DEFAULT_CORPORATION({commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      return axios.post(`/groupdef/setSuperSuperUserDefaultCorp`, payload)
        .then((response) => {
          commit('TOGGLE_LOADING', false);
          const { data: { data } } = response;
          console.log('UPDATE_USER_CORP ', response);
          resolve(data);
        })
        .catch((error) => {
          commit('TOGGLE_LOADING', false);
          console.log('UPDATE_EXPERT error ', error);
          reject(error);
        })
    })
  },
  UPDATE_EMAIL_TEMPLATE({commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      return axios.post(`/emailapis/updateTeaserEmailContent`, payload)
        .then((response) => {
          commit('TOGGLE_LOADING', false);
          const { data: { data } } = response;
          console.log('UPDATE_USER_CORP ', response);
          resolve(data);
        })
        .catch((error) => {
          commit('TOGGLE_LOADING', false);
          console.log('UPDATE_EXPERT error ', error);
          reject(error);
        })
    })
  },
    UPDATE_CORPORATION({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            let formData = new FormData();
            payload.corporation = JSON.stringify(payload.corporation);
            formData.append("corporation", payload.corporation);
            payload.largeImage.length &&  formData.append("large_file", payload.largeImage[0]);
            payload.smallImage.length && formData.append("small_file", payload.smallImage[0]);

            return axios.put(`/corporations`, formData)
                .then((response) => {
                    commit('TOGGLE_LOADING', false);
                    const { data: { data } } = response;
                    console.log('UPDATE_EXPERT response ', response);
                    resolve(data);
                })
                .catch((error) => {
                    commit('TOGGLE_LOADING', false);
                    console.log('UPDATE_EXPERT error ', error);
                    reject(error);
                })
        })
    },

    ADD_CORPORATION({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            let formData = new FormData();
            payload.corporation = JSON.stringify(payload.corporation);
            formData.append("corporation", payload.corporation);
            formData.append("large_file", payload.largeImage);
            formData.append("small_file", payload.smallImage);

            return axios.post(`/corporations`, formData)
                .then((response) => {
                    commit('TOGGLE_LOADING', false);
                    const { data: { data } } = response;
                    console.log('ADD_CORPORATION response ', response);
                    resolve(data);
                })
                .catch((error) => {
                    commit('TOGGLE_LOADING', false);
                    console.log('ADD_CORPORATION error ', error);
                    reject(error);
                })
        })
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/corporations/actions.js